<template>
	<div class="filter-wrapper" v-show="facets && facets.length > 0">
		<button
			class="btn btn-link filter-toggle d-inline-block d-md-none"
			@click="toggleOpeningState(-1, $event.target)"
			@mouseover.once="initializeFilterView()"
			:class="selectedFacetIds.some((r) => allFacetValueIDs.includes(r)) ? 'active-facet' : ''"
		>
			{{ $translate("Ceres::Template.itemFilter") }}
		</button>
		<button
			class="btn btn-link filter-toggle d-none d-md-inline-block"
			@click="toggleOpeningState(facet.id, $event.target)"
			@mouseover.once="initializeFilterView()"
			v-for="facet in filteredButtonFacets"
			:key="facet.id"
			:class="[
				facet.cssClass,
				activeFacetID === facet.id ||
				(hasBothGroupedIDs && facetGroupIds.includes(activeFacetID) && facetGroupIds.includes(facet.id))
					? 'filter-button-active'
					: '',
				selectedFacetIds.some((r) => {
					if (typeof facetValueIDs[facet.id] === 'undefined') {
						return true;
					}
					return facetValueIDs[facet.id].includes(r)
				}) ||
				(hasBothGroupedIDs &&
					facetGroupIds.includes(facet.id) &&
					selectedFacetIds.some((r) => secondFacetIDs.includes(r)))
					? 'active-facet'
					: ''
			]"
		>
			{{ facet.name }}
		</button>
		<div v-if="isActive || prefetch" v-show="isActive" class="collapse" :class="{ show: isActive }" id="filterCollapse" ref="filterCollapse">
			<button
				type="button"
				id="close-filter"
				data-toggle="collapse"
				href="#filterCollapse"
				aria-controls="filterCollapse"
				@click="toggleOpeningState(-1)"
			>
				<i class="fa fa-times"></i>
			</button>
			<div class="container-max page-content component-loading" :class="{ isLoading: isLoading }">
				<div class="card-columns filter-columns"></div>
				<div class="filter-column-container">
					<div class="filter-column" data-column="1">
						<item-filter
							v-for="facet in firstColumnFilters"
							:facet="facet"
							:key="facet.id"
							:class="{
								'facet-active-opened':
									activeFacetID === facet.id ||
									(hasBothGroupedIDs &&
										facetGroupIds.includes(activeFacetID) &&
										facetGroupIds.includes(facet.id))
							}"
							:is-grouped-facet="facetGroupIds.includes(facet.id)"
							:second-facet-ids="hasBothGroupedIDs && facet.id === facetGroupIds[0] ? secondFacetIDs : []"
							:facet-value-ids="facetValueIDs[facet.id]"
							v-bind="{
								facetGroupIds: facetGroupIds,
								hasBothGroupedIDs: hasBothGroupedIDs,
								selectedFacetIds: selectedFacetIds
							}"
						></item-filter>
					</div>
					<div class="filter-column" data-column="2">
						<item-filter
							v-for="facet in secondColumnFilters"
							:facet="facet"
							:key="facet.id"
							:class="{
								'facet-active-opened':
									activeFacetID === facet.id ||
									(hasBothGroupedIDs &&
										facetGroupIds.includes(activeFacetID) &&
										facetGroupIds.includes(facet.id))
							}"
							:is-grouped-facet="facetGroupIds.includes(facet.id)"
							:second-facet-ids="hasBothGroupedIDs && facet.id === facetGroupIds[0] ? secondFacetIDs : []"
							:facet-value-ids="facetValueIDs[facet.id]"
							v-bind="{
								facetGroupIds: facetGroupIds,
								hasBothGroupedIDs: hasBothGroupedIDs,
								selectedFacetIds: selectedFacetIds
							}"
						></item-filter>
					</div>
					<div class="filter-column" data-column="3">
						<item-filter
							v-for="facet in thirdColumnFilters"
							:facet="facet"
							:key="facet.id"
							:class="{
								'facet-active-opened':
									activeFacetID === facet.id ||
									(hasBothGroupedIDs &&
										facetGroupIds.includes(activeFacetID) &&
										facetGroupIds.includes(facet.id))
							}"
							:is-grouped-facet="facetGroupIds.includes(facet.id)"
							:second-facet-ids="hasBothGroupedIDs && facet.id === facetGroupIds[0] ? secondFacetIDs : []"
							:facet-value-ids="facetValueIDs[facet.id]"
							v-bind="{
								facetGroupIds: facetGroupIds,
								hasBothGroupedIDs: hasBothGroupedIDs,
								selectedFacetIds: selectedFacetIds
							}"
						></item-filter>
					</div>
				</div>
				<div class="row button-container">
					<div class="col-12 text-right">
						<button
							v-if="selectedFacets.length > 0"
							type="button"
							class="btn btn-outline-primary btn-medium-large"
							@click="removeFacetSelection"
						>
							<i class="fa fa-trash" aria-hidden="true"></i>
							{{ $translate("Ceres::Template.itemFilterReset") }}
						</button>
						<button type="button" class="btn btn-primary btn-medium-large" @click="toggleOpeningState(-1)">
							<i
								:class="{
									'fa-times': isInitialFacetSelectionActive,
									'fa-check': !isInitialFacetSelectionActive
								}"
								class="fa"
								aria-hidden="true"
							></i>
							<span v-if="isInitialFacetSelectionActive"
								>{{ $translate("Ceres::Template.itemClose") }}&nbsp;</span
							>
							<span v-else>{{ $translate("Eros::Template.itemFilterApply") }}&nbsp;</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import UrlService from "../../../services/UrlService";
import { mapState } from "vuex";
import { isDefined } from "../../../../ceres/helper/utils";
import { PrefetchMixin } from "../../../mixins/prefetch.js";
// import ItemFilter from "../../../../ceres/components/itemList/filter/ItemFilter.vue";

export default {
	name: "item-filter-list",

	props: {
		facetData: {
			type: Array,
			default() {
				return [];
			}
		},
		facetGroupIds: {
			type: Array,
			default() {
				return [];
			}
		},
        isPreview:
        {
            type: Boolean,
            default: false
        }
	},

	mixins: [PrefetchMixin],

	data() {
		return {
			initialSelectedFacets: [],
			allFacetValueIDs: [],
			initialPriceMin: "",
			initialPriceMax: "",
			isActive: false,
			toggledButton: null
		};
	},

    watch:
    {
        facetData()
        {
			if (!this.isPreview) {
				this.setAllFacetValueIDs();
			}
        }
    },

	computed: {
		facetValueIDs() {
			if (this.facetData?.length > 0) {
				return Object.assign(
					...this.facetData.map((facet) => {
						let relay = {};

						if (facet.type === "price") {
							relay[facet.id] = ["price"];
						} else {
							relay[facet.id] = facet.values.map((facetValue) => facetValue.id);
						}

						return relay;
					})
				);
			}
			return [];
		},

		selectedFacetIds() {
			return this.selectedFacets.map((facet) => facet.id);
		},

		isInitialFacetSelectionActive() {
			if (!this.isInitialPriceFacetActive) {
				return false;
			}

			if (this.initialSelectedFacets?.length === this.selectedFacetIds?.length) {
				for (const selectedFacetId of this.selectedFacetIds) {
					if (
						!this.initialSelectedFacets.find(
							(initialFacetId) => initialFacetId.toString() === selectedFacetId.toString()
						)
					) {
						return false;
					}
				}

				return true;
			}

			return false;
		},

		isInitialPriceFacetActive() {
			const currentPriceFacet = this.selectedFacets.filter((facet) => facet.id === "price")[0];

			// no initial price facet and no current one
			if (!this.initialPriceMin && !this.initialPriceMax && !currentPriceFacet) {
				return true;
			}

			if (currentPriceFacet) {
				if (
					currentPriceFacet.priceMin === this.initialPriceMin &&
					currentPriceFacet.priceMax === this.initialPriceMax
				) {
					return true;
				}
			}

			return false;
		},

		hasBothGroupedIDs() {
			let foundGroupedIDs = 0;

			if (this.facetGroupIds?.length === 2 && this.facetData?.length > 1) {
				let self = this;

				this.facetData.forEach((facet) => {
					if (self.facetGroupIds.includes(facet.id)) {
						foundGroupedIDs++;
					}
				});
			}
			return foundGroupedIDs === 2;
		},

		secondFacetIDs() {
			let IDs = [];

			if (this.facetGroupIds?.length === 2 && this.facetData?.length > 0) {
				let self = this;

				this.facetData.forEach((facet) => {
					if (facet.id === self.facetGroupIds[1]) {
						facet.values.forEach((facetValues) => {
							IDs.push(facetValues.id);
						});
					}
				});
			}

			return IDs;
		},

		firstColumnFilters() {
			return this.facets.filter((facet) => {
				return facet.position <= 3;
			});
		},

		secondColumnFilters() {
			return this.facets.filter((facet) => {
				return facet.position > 3 && facet.position <= 6;
			});
		},

		thirdColumnFilters() {
			return this.facets.filter((facet) => {
				return facet.position > 6;
			});
		},

		filteredButtonFacets() {
			return this.facets.filter((facet) => {
				return (
					!this.facetGroupIds.includes(facet.id) ||
					(this.hasBothGroupedIDs && facet.id === this.facetGroupIds[0]) ||
					(!this.hasBothGroupedIDs && this.facetGroupIds.includes(facet.id))
				);
			});
		},

		...mapState({
			facets: (state) => {
				if (
					isDefined(state.itemList?.facets)
				) {
					if (state.itemList.facets.length >= 2) {
						return state.itemList.facets.sort((facetA, facetB) => {
							if (facetA.position > facetB.position) {
								return 1;
							}
							if (facetA.position < facetB.position) {
								return -1;
							}

							return 0;
						});
					} else {
						return state.itemList.facets;
					}
				} else {
					return [];
				}
			},
			isLoading: (state) => state.itemList.isLoading,
			selectedFacets: (state) => state.itemList.selectedFacets,
			activeFacetID: (state) => state.itemList.activeFacetID
		})
	},

	created() {
		if (!this.$store.state.itemList.facets?.length)
        {
            this.$store.commit("addFacets", this.facetData);
        }
		if (!this.isPreview && this.facets?.length === 0) {
			this.$store.commit("setFacets", this.facetData);
			
			this.$options.template = this.template;
		}
	},

	beforeMount() {
		if (App.Eros.Config.general.benchmarkJS) console.time("App.eros.components.itemList.filter.ItemFilterList: mount"); // eslint-disable-line no-console
	},


	mounted() {
		if (App.Eros.Config.general.benchmarkJS) console.timeEnd("App.eros.components.itemList.filter.ItemFilterList: mount"); // eslint-disable-line no-console
		if (App.Eros.Config.general.benchmarkJS) console.time("App.eros.components.itemList.filter.ItemFilterList: mounted"); // eslint-disable-line no-console
		const urlParams = UrlService.getUrlParams(document.location.search);

		let selectedFacets = [];

		if (urlParams.facets) {
			selectedFacets = urlParams.facets.split(",");
		}

		if (urlParams.priceMin || urlParams.priceMax) {
			const priceMin = urlParams.priceMin || "";
			const priceMax = urlParams.priceMax || "";

			this.$store.commit("setPriceFacet", {
				priceMin: priceMin,
				priceMax: priceMax
			});

			this.initialPriceMin = priceMin;
			this.initialPriceMax = priceMax;

			selectedFacets.push("price");
		}

		if (selectedFacets.length > 0) {
			this.$store.commit("setSelectedFacetsByIds", selectedFacets);
		}

		this.initialSelectedFacets = selectedFacets;

		if (App.Eros.Config.general.benchmarkJS) console.timeEnd("App.eros.components.itemList.filter.ItemFilterList: mounted"); // eslint-disable-line no-console
	},

	methods: {
		toggleOpeningState(activeFacetID, element = null) {
			const previousActiveFacetID = this.activeFacetID;

			this.$store.commit("focusFacet", activeFacetID);
			this.toggledButton = element;
			if (
				!this.isActive ||
				(this.isActive && (previousActiveFacetID === activeFacetID || activeFacetID === -1))
			) {
				$(this.$refs.filterCollapse).collapse("toggle");
			}

			window.setTimeout(() => {
				if (this.isActive && !this.isInitialFacetSelectionActive) {
					if (activeFacetID === -1 || previousActiveFacetID === activeFacetID) {
						this.$store.dispatch("loadItemList");
					}
				}

				if (!this.isActive || previousActiveFacetID === activeFacetID || activeFacetID === -1) {
					this.isActive = !this.isActive;
				}
			}, 300);
		},

		removeFacetSelection() {
			if (this.selectedFacets?.length > 0) {
				this.$store.dispatch("selectFacets", [this.selectedFacets]);

				if (this.initialSelectedFacets?.length > 0) {
					this.$store.dispatch("loadItemList");
				}
			}
		},

		setAllFacetValueIDs() {
			var relay = [];

			if (this.facetData?.length > 0) {
				this.facetData.forEach((facet) => {
					if (facet.type === "price") {
						relay.push("price");
					} else {
						relay.push(...facet.values.map((facetValue) => facetValue.id));
					}
				});
			}

			this.allFacetValueIDs = relay;
		},

		initializeFilterView() {
			this.$store.dispatch("loadComponent", "item-filter");
		}
	}
};
</script>